export default __webpack_public_path__ + "static/media/time-2.af3daf18.svg";